import React from "react";
import { graphql } from 'gatsby';
import TagBlogsList from "./tagBlogList";

export const tagPageQuery = graphql`query ($tagSlug: String!, $skip: Int!, $limit: Int!) {
  allWordpressPost(
    limit: $limit
    skip: $skip
    sort: {order: DESC, fields: date}
    filter: {tags: {elemMatch: {slug: {eq: $tagSlug}}}}
  ) {
    edges {
      node {
        title
        featured_media {
          source_url
          alt_text
          localFile {
            childImageSharp {
              gatsbyImageData(width: 860, layout: CONSTRAINED)
            }
          }
        }
        slug
        content
        date(formatString: "DD MMMM, YYYY")
        categories {
          name
          slug
        }
        acf {
          lending_page_image {
            source_url
          }
        }
      }
    }
  }
  allWordpressTag(
    filter: {name: {in: ["Retail", "Manufacturing", "Logistics", "Healthcare"]}}
  ) {
    edges {
      node {
        name
        count
        slug
      }
    }
  }
}
`;

const TagBlogPage = (props, { location }) => {
  return (
    <TagBlogsList data={props} location={location} tag={props.pageContext.tagName} />
  );
};

export default TagBlogPage;;